import { Helmet } from 'react-helmet-async'

import {
  Box, Columns, LoadingModule, PageHeader,
} from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import groupDataStoreItems from '@functions/groupDataStoreItems'
import { getCampaignPermissions, getCampaignType } from '@functions/campaign'

import useCampaignSelector from '@hooks/useCampaignSelector'
import useCurrentUser from '@hooks/useCurrentUser'
import useDataStoreItems from '@hooks/useDataStoreItems'

import defaultRequestOptions from '@sections/Client/packs/Campaign/defaultRequestOptions'
import propertyDetailsTabBarItems from '@sections/Client/packs/Campaign/utils/generatePropertyDetailsTabBarItems'

import DataStoreBlankState from '../DataStoreBlankState'
import DataStoreGroup from '../DataStoreGroup'

const PageContent = () => {
  const { campaignId } = useNumericParams()

  const dataStoreItemsPayload = useDataStoreItems({
    filters: {
      hidden: false,
      limit: 300,
      owner_id: campaignId,
      owner_type: 'Campaign',
    },
    performHttpRequests: !!campaignId,
    requestOptions: defaultRequestOptions.dataStoreItem,
  })

  const {
    filteredDataStoreItems,
    hasFilteredDataStoreItems,
    loading,
  } = dataStoreItemsPayload

  const groupedDataStoreItems = groupDataStoreItems(filteredDataStoreItems)

  const { campaign, campaign: { address } } = useCampaignSelector()

  const { currentUser } = useCurrentUser()
  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Data Store</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="data-store"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={propertyDetailsTabBarItems(campaignId, campaignPermissions)}
        title="Data Store"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.campaign.dataStore.banner" />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredDataStoreItems && <DataStoreBlankState />}

            {!loading && Object.values(groupedDataStoreItems).map((group, _, arr) => (
              // @ts-expect-error TS2322
              <DataStoreGroup isSingleGroup={arr.length === 1} key={group.key} group={group} />
            ))}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.campaign.dataStore.sidebar" />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
